/**
 * PMD Explorer environment.
 *
 * The explorer is served at the domain root and talks to its own BFF
 * (`bff-explorer`), which proxies the PMD API and handles authentication.
 */
export const environment = {
  serverUrl: `${window.location.origin}/pmd-api/v1`,
  liftCapacityUrl: `${window.location.origin}/liftcapacityreport/`,
  bffConfig: {
    url: '',
    api: '/bff/pmd-api/v1',
    login: '/bff/login',
    logout: '/bff/logout',
    user: '/bff/user',
  },
};
